import React from "react";
import styles from "./subContent.module.css";
import angledown from "../static/images/component_svg/angle-down_orange.svg";
import { useState } from "react";
import { useMemo } from "react";
import faster from "../static/images/component_svg/faster.svg";
import same from "../static/images/component_svg/same.svg";
import slower from "../static/images/component_svg/slower.svg";

function SubContent({ result }) {
  const [isVisible, setIsVisible] = useState(false);
  const performanceImages = {
    faster,
    same,
    slower,
  };

  const performanceLists = {
    slower: {
      status: "ทักษะสมองพัฒนาได้อีก",
      detail:
        "หมายถึง สมองทำงานช้ากว่าเกณฑ์เมื่อเทียบกับอายุจริง จึงควรปรับพฤติกรรมอย่างจริงจัง เช่น ตรวจสุขภาพ ออกกำลังกาย ฝึกความจำ ฝึกสติ และพักผ่อนให้เพียงพอ เพื่อชะลอการเสื่อมของสมอง",
    },
    same: {
      status: "ทักษะสมองตามวัย",
      detail:
        "หมายถึง สมองทำงานสอดคล้องกับอายุจริง อยู่ในเกณฑ์ปกติ ควรรักษาสุขภาพกาย-ใจ ทำกิจกรรมฝึกสมอง เรียนรู้สิ่งใหม่ และฝึกสติสม่ำเสมอ เพื่อคงความแข็งแรงของสมองอย่างต่อเนื่อง",
    },
    faster: {
      status: "ทักษะสมองดีเยี่ยม",
      detail:
        "หมายถึง สมองทำงานได้ดีกว่าค่าเฉลี่ยของช่วงวัย แสดงถึงศักยภาพที่โดดเด่น ควรต่อยอดด้วยการเรียนรู้สิ่งใหม่ กิจกรรมสร้างสรรค์ และการฝึกที่ท้าทาย เพื่อรักษาศักยภาพนี้ให้อยู่กับตัวไปได้นานที่สุด",
    },
  };

  const toggleVisibility = () => {
    setIsVisible((prevState) => !prevState);
  };
  return (
    <div className={styles.other_result}>
      <div className={styles.sub_content} onClick={toggleVisibility}>
        <h2>คำอธิบายผลลัพธ์</h2>
        <img
          className={`${styles.arrow} ${isVisible ? "" : styles.arrowActive}`}
          src={angledown}
          alt="downArrow"
        />
      </div>
      <div
        className={`${styles.bodyresultbox} ${isVisible ? styles.open : ""}`}
      >
        <div className={styles.boxcontent}>
          <p>
            เมื่อเทียบกับอายุสมองกับอายุจริง ผลลัพธ์แต่ละแบบมีความหมายดังนี้
          </p>
          {Object.keys(performanceLists).map((item) => (
            <div className={styles.res}>
              <div className={styles.top}>
                <img
                  className={
                    item === "slower" ? styles.brainImageSlow : styles.brainImage
                  }
                  src={performanceImages[item]}
                  alt="statusperformance"
                ></img>

                <h2 className={styles[item]}>
                  {performanceLists[item].status}
                </h2>
              </div>
              <p>{performanceLists[item].detail}</p>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

export default SubContent;
